import { render } from "./TransportationItemComponent.vue?vue&type=template&id=2ce419ce&scoped=true&ts=true"
import script from "./TransportationItemComponent.vue?vue&type=script&lang=ts"
export * from "./TransportationItemComponent.vue?vue&type=script&lang=ts"

import "./TransportationItemComponent.vue?vue&type=style&index=0&id=2ce419ce&lang=scss&scoped=true"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce419ce"]])

export default __exports__